<template>
    <div class="artist" :class="{ full: full }">
        <div class="image">
            <img
                :src="teaser ? featuredImage : bioImage"
                v-if="allArtworks.length && featuredImage"
                loading="lazy"
            />
        </div>
        <div class="details">
            <template v-if="full">
                <h1>{{ artist.name }}</h1>
            </template>
            <template v-else>
                <h3 class="artist-title"><router-link :to="artist.url">{{ artist.name }}</router-link></h3>
            </template>
            <div class="bio" v-if="full">
                <div class="teaser" v-show="hideFullBody">
                    <div class="text" v-html="artist.teaser"></div>
                    <a @click="showFullBody = true">More...</a>
                </div>
                <div
                    class="body"
                    v-html="artist.body"
                    v-show="showFullBody"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import { Artworks } from "@/state.js";
import { API_URI } from "@/helpers/config";

export default {
    name: "Artist",
    data() {
        return {
            showFullBody: false,
            allArtworks: Artworks,
        };
    },
    props: {
        artist: Object,
        teaser: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        bioImage() {
            return (
                this.artist.bio_image && API_URI + "/" + this.artist.bio_image
            );
        },
        featuredImage() {
            const vm = this;
            const work = vm.allArtworks.find((a) => a.uid == vm.artist.uid);
            if (!work) return vm.bioImage;
            const thumb = work.image.replace(
                "sites/default/files/",
                "sites/default/files/imagecache/artwork_thumb/"
            );
            return API_URI + "/" + thumb;
        },
        full() {
            return !this.teaser;
        },
        hideFullBody() {
            return !this.showFullBody;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
